import { ref, onMounted } from 'vue'
import { ItemWrapper } from '@/wrappers'
import { CubeIcon } from '@heroicons/vue/24/outline'
import type { Material, FormData, FormInfo, DataFile, FormSelectOption, RequestType } from '@/interfaces'

export function useMaterial(skipLoading: boolean = false) {

    const baseForm: FormData = {
        name: null,
        price: null
    };

    const wrapper = new ItemWrapper<Material>("materials");

    const empty = {...baseForm};

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const info = ref<FormInfo>();
    const materials = ref<Material[]>([]);
    const materialOptions = ref<FormSelectOption[]>([]);

    async function addMaterial(): Promise<void> {
        request.value = {...request.value , error: null , response: null , isLoading: !request.value.isLoading}

        await wrapper.addItem(getData()).then((data) => request.value.response = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.data = {...empty};
        request.value.isLoading = !request.value.isLoading;
    }

    function getAsFormOptions(): void {
        materialOptions.value = materials.value.map(material => {
            return {
                value: material.id,
                label: material.name,
                command: `€ ${material.price}`,
                icon: CubeIcon
            }
        });
    }

    async function getMaterials(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getItems().then((data) => materials.value = data);

        getAsFormOptions();
        request.value.isLoading = !request.value.isLoading;
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    function getData(): DataFile {
        return {
            file: null,
            data: JSON.stringify(request.value.data)
        }
    }

    onMounted(() => {
        if (skipLoading) return;

        getMaterials();
    });

    return {
        info,
        request,
        materials,
        materialOptions,
        getInfo,
        addMaterial,
        getMaterials
    }
}